var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76857 10.7761L0.146076 5.87336C-0.048692 5.66698 -0.048692 5.33356 0.146076 5.12664L4.76857 0.223935C5.04973 -0.0746449 5.50719 -0.0746449 5.78885 0.223935C6.07002 0.522514 6.07002 1.0071 5.78885 1.30568L1.83456 5.50027L5.78885 9.69378C6.07002 9.9929 6.07002 10.4775 5.78885 10.7761C5.50719 11.0746 5.04973 11.0746 4.76857 10.7761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.03872f348cc713fe0b91a78f249b4ba7.svg";
export { ForwardRef as ReactComponent };